import React, { useState, useEffect } from "react";
import GalleryShowcase from "./GalleryShowcasedImage";
import ThumbnailList from "./GalleryThumbnailList";
import PreLoader from "./PreLoader";

interface Image {
  image: string;
}

interface ProductData {
  images: Image[];
  video?: string;
}

interface GalleryProps {
  thumbnailSelected?: { current: number };
  productData: ProductData[];
}

const Gallery: React.FC<GalleryProps> = (props) => {
  const defaultThumbnail = props?.thumbnailSelected
    ? props?.thumbnailSelected.current
    : 0;
  const TelligentData = props?.productData;
  const thumbnailImages = TelligentData[0]?.images;
  const videoUrl = TelligentData[0]?.video ? TelligentData[0]?.video : null;
  const [selectedImage, setSelectedImage] = useState<string>(
    thumbnailImages[defaultThumbnail]?.image
  );
  const [videoSelected, setVideoSelected] = useState<boolean>(
    videoUrl !== null && defaultThumbnail === 0 ? true : false
  );
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const updateSelectedImage = (img: string) => {
      setSelectedImage(img);
  };

  useEffect(() => {
    if (TelligentData) {
      updateSelectedImage(thumbnailImages[defaultThumbnail]?.image);
      setIsLoading(false);
    }
  }, [TelligentData]);

 
  return (
    <div className="md:tw-p-4 tw-pb-0 ln-thumbnail-section tw-h-full tw-overflow-y-auto">
      {isLoading ? (
        <PreLoader />
      ) : (
        <>
          <GalleryShowcase
            selectedImage={selectedImage}
            video={videoUrl || ""}
            videoSelected={videoSelected}
           />
          <ThumbnailList
            images={thumbnailImages}
            defaultThumbnail={defaultThumbnail}
            updateSelectedImage={updateSelectedImage}
            video={videoUrl}
            setVideoSelected={setVideoSelected}
          />
        </>
      )}
    </div>
  );
};

export default Gallery;
